/**
 * BattleListReq 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'

/**
 * BattleListReq
 */
export interface BattleListReq {
  /** 搜索关键词 */
  q?: string
  /** 是否删除 */
  deleted?: boolean
  /** 页码 */
  page?: number
  /** 每页数量 */
  page_size?: number
  /** 排序字段 */
  order_by?: string
  /** 排序方向 */
  order?: string
  /** 创建时间范围 (start,end) */
  created_at__range?: any
  /** 更新时间范围 (start,end) */
  updated_at__range?: any
  /** 更新时间距今 (7d/1h/30m) */
  updated_at__since?: any
  /** 禁用状态 */
  disabled?: boolean
  /** ID列表 */
  id__in?: string[]
  /** 对线阶段 */
  stage?: string
  /** 胜负状态 */
  victory_state?: string
  /** 最小成员数 */
  member_count__gte?: number
  /** 最大成员数 */
  member_count__lte?: number
  /** 最小时长(秒) */
  duration__gte?: number
  /** 最大时长(秒) */
  duration__lte?: number
  /** 对线阶段列表 */
  stage__in?: string[]
  /** 开始时间距今 */
  started_at__since?: string
  /** 结束时间距今 */
  finished_at__since?: string
  /** 红方名称包含 */
  red_name__like?: string
  /** 蓝方名称包含 */
  blue_name__like?: string
}

/**
 * BattleListReq Schema
 */
export const BattleListReqSchema: SchemaDefinition = {
  properties: {
    q: {
      description: '搜索关键词',
      format: 'string',
      type: 'string',
      label: '搜索关键词',
    },
    deleted: {
      description: '是否删除',
      format: '*bool',
      type: 'boolean',
      label: '是否删除',
    },
    page: {
      description: '页码',
      format: 'int',
      type: 'integer',
      label: '页码',
    },
    page_size: {
      description: '每页数量',
      format: 'int',
      type: 'integer',
      label: '每页数量',
    },
    order_by: {
      description: '排序字段',
      format: 'string',
      type: 'string',
      label: '排序字段',
    },
    order: {
      description: '排序方向',
      format: 'string',
      type: 'string',
      label: '排序方向',
    },
    created_at__range: {
      description: '创建时间范围 (start,end)',
      format: '[]string',
      type: 'datetime',
      label: '创建时间范围',
    },
    updated_at__range: {
      description: '更新时间范围 (start,end)',
      format: '[]string',
      type: 'datetime',
      label: '更新时间范围',
    },
    updated_at__since: {
      description: '更新时间距今 (7d/1h/30m)',
      format: '[]string',
      type: 'datetime',
      label: '更新时间距今',
    },
    disabled: {
      description: '禁用状态',
      format: '*bool',
      type: 'boolean',
      label: '禁用状态',
    },
    id__in: {
      description: 'ID列表',
      format: '[]string',
      items: {
        format: 'string',
        type: 'string',
      },
      type: 'array',
      label: 'ID列表',
    },
    stage: {
      description: '对线阶段',
      format: 'cons.BattleStage',
      type: 'string',
      label: '对线阶段',
    },
    victory_state: {
      description: '胜负状态',
      format: 'cons.BattleVictoryState',
      type: 'string',
      label: '胜负状态',
    },
    member_count__gte: {
      description: '最小成员数',
      format: '*int',
      type: 'integer',
      label: '最小成员数',
    },
    member_count__lte: {
      description: '最大成员数',
      format: '*int',
      type: 'integer',
      label: '最大成员数',
    },
    duration__gte: {
      description: '最小时长(秒)',
      format: '*int',
      type: 'integer',
      label: '最小时长',
    },
    duration__lte: {
      description: '最大时长(秒)',
      format: '*int',
      type: 'integer',
      label: '最大时长',
    },
    stage__in: {
      description: '对线阶段列表',
      format: '[]cons.BattleStage',
      items: {
        format: 'cons.BattleStage',
        type: 'string',
      },
      type: 'array',
      label: '对线阶段列表',
    },
    started_at__since: {
      description: '开始时间距今',
      format: '*string',
      type: 'string',
      label: '开始时间距今',
    },
    finished_at__since: {
      description: '结束时间距今',
      format: '*string',
      type: 'string',
      label: '结束时间距今',
    },
    red_name__like: {
      description: '红方名称包含',
      format: 'string',
      type: 'string',
      label: '红方名称包含',
    },
    blue_name__like: {
      description: '蓝方名称包含',
      format: 'string',
      type: 'string',
      label: '蓝方名称包含',
    },
  },
  type: 'object',
}
